class SoundComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { SoundComponentData };
